
import axios from "axios"


function GetStatsByCountry({country})
{
    return axios({
            "method":"GET",
            "url":"https://covid-19-coronavirus-statistics.p.rapidapi.com/v1/stats",
            "headers":{
            "content-type":"application/octet-stream",
            "x-rapidapi-host":"covid-19-coronavirus-statistics.p.rapidapi.com",
            "x-rapidapi-key":"aca2b4d924msh2f16a2f5fbe57cdp169f67jsn649feb8a7d62"
            },"params":{
            "country":`${country}`
            }
        })            
}

function GetCasesByCountry()
{    
    return  axios({
        "method":"GET",
        "url":"https://coronavirus-monitor.p.rapidapi.com/coronavirus/cases_by_country.php",
        "headers":{
        "content-type":"application/octet-stream",
        "x-rapidapi-host":"coronavirus-monitor.p.rapidapi.com",
        "x-rapidapi-key":"aca2b4d924msh2f16a2f5fbe57cdp169f67jsn649feb8a7d62"
        }
        })           
}

function GetZipCode(lat, lng)
{ 
    return  axios({
        "method":"GET",
        "url":`https://us1.locationiq.com/v1/reverse.php?key=2458791b99c2a7&lat=${lat}&lon=${lng}&format=json`
    })     
}

function GetLocationFromZipCode(Zipcode,countrycode){
    return  axios({
        "method":"GET",
        "url":`https://us1.locationiq.com/v1/search.php?key=2458791b99c2a7&postalcode=${Zipcode}&countrycodes=${countrycode}&format=json`
    })     
}

function GetStatsByCounty({country})
{
    return axios({
            "method":"GET",
            "url":"https://coronadatascraper.com/data.json",
        })            
}



export {GetStatsByCountry, GetCasesByCountry, GetZipCode, GetLocationFromZipCode, GetStatsByCounty};